import React, { useEffect, useState } from 'react'

import { Container } from './styles'
import ProgressBar from '~/components/ProgressBar'

let interval
let intervalProgresso
let chatTrigger
const timeout = 50

export default function () {
	const [chatIsLoaded, setChatIsLoaded] = useState(false)
	const [isLoading, setIsLoading] = useState(true)
	const [progresso, setProgresso] = useState(0)

	async function ajustarChat() {
		chatTrigger.click()

		await new Promise(r => setTimeout(r, timeout))

		const menuTrigger = document.querySelector('#chatbox-menu-trigger')

		if(menuTrigger) {
			await new Promise(r => setTimeout(r, timeout))

			menuTrigger.click()
			
			await new Promise(r => setTimeout(r, timeout))

			const positionTrigger = document.querySelector('#chatbox-position-center')

			positionTrigger?.click()

			await new Promise(r => setTimeout(r, timeout))

			menuTrigger.click()

			clearInterval(intervalProgresso)
		}
	} 

	useEffect(() => {
		const script = document.createElement('script')

		// script.src = 'http://localhost:3030/positronic-chat.js'
		script.src = 'https://sindmepa-chat.nyr4mj.easypanel.host/positronic-chat.js'

		const chatJaIncluido = !!document.querySelector('script[src^="https://sindmepa-chat"]')
		// const chatJaIncluido = !!document.querySelector('script[src^="http://localhost:3030"]')

		if (!chatJaIncluido) {
			document.body.appendChild(script)
		}

		setChatIsLoaded(true)

		return () => {
			const chatbox = document.querySelector('#chatbox')

			if(chatbox) {
				chatbox.style.display = 'none'
			}
		}
	}, [])

	useEffect(() => {
		if(chatIsLoaded && !interval) {
			interval = setInterval(() => {
				if(!chatTrigger) {
					chatTrigger = document.querySelector('#chatbot-minimize-trigger')
					
					if(chatTrigger) {
						setIsLoading(false)

						ajustarChat()
					}
				} else {
					clearInterval(interval)
				}
			}, 1000)
		}

		return () => {
			clearInterval(interval)
		}
	}, [chatIsLoaded])

	useEffect(() => {
		intervalProgresso = setInterval(() => {
			setProgresso(old => {
				if(old > 80) {
					location.reload()
				}

				return old < 100 ? old + 4 : old
			})
		}, 1000)

		return () => {
			clearInterval(intervalProgresso)
		}
	}, [])

	return (
		<Container>
			<h1 className="font-semibold mt-6 text-slate-800">Assistente sobre o Código de Ética Médica</h1>

			{isLoading && (
				<div className="my-6 mx-auto font-semibold text-slate-600 text-center">
					<ProgressBar
						visible
						percentage={progresso}
						hint="Carregando..."
						style={{
							width: 300
						}}
					/>
				</div>
			)}
		</Container>
	)
}
